module.exports = __webpack_public_path__ + "static/media/A1-27-Groxxyn-cod125.9b3adf16.png";